import { Box, Circle } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import {
  TodoListItemTags_tag$data,
  TodoListItemTags_tag$key,
} from "./__generated__/TodoListItemTags_tag.graphql";
import { FormattedMessage } from "react-intl";
import { TodoListItemFooterLabel } from "./TodoListItemFooterItem";

export function TodoListItemTags(props: {
  tags: TodoListItemTags_tag$key;
  maxWidth?: number;
}) {
  const tags = useFragment(
    graphql`
      fragment TodoListItemTags_tag on TodoCategoryTag @relay(plural: true) {
        id
        color
        title
      }
    `,
    props.tags
  );

  if (tags.length === 0) {
    return null;
  }

  if (tags.length === 1) {
    return <TodoListItemTagsSingleTag tags={tags} maxWidth={props.maxWidth} />;
  } else {
    return <TodoListItemTagsMultipleTags tags={tags} />;
  }
}

function TodoListItemTagsSingleTag(props: {
  tags: TodoListItemTags_tag$data;
  maxWidth?: number;
}) {
  const tag = props.tags[0];
  return (
    <>
      <Box style={{ flexDirection: "row" }} spaceRight="xxsmall">
        <TagCircle color={tag.color} isFirst />
      </Box>
      <TodoListItemFooterLabel maxWidth={props.maxWidth}>
        {tag.title}
      </TodoListItemFooterLabel>
    </>
  );
}

function TagCircle(props: { color: string; isFirst?: boolean }) {
  return (
    <Circle
      style={{ marginLeft: props.isFirst ? 0 : -3 }}
      size="badge"
      color="surface-primary"
    >
      <Circle
        size="dot"
        style={{
          backgroundColor: props.color,
        }}
      />
    </Circle>
  );
}

function TodoListItemTagsMultipleTags(props: {
  tags: TodoListItemTags_tag$data;
}) {
  return (
    <>
      <Box style={{ flexDirection: "row" }} spaceRight="xxsmall">
        {props.tags.map((tag, index) => (
          <TagCircle key={tag.id} color={tag.color} isFirst={index === 0} />
        ))}
      </Box>
      <TodoListItemFooterLabel>
        <FormattedMessage
          defaultMessage="{count} tags"
          description="TodoListItemTags number of tags"
          values={{
            count: props.tags.length,
          }}
        />
      </TodoListItemFooterLabel>
    </>
  );
}
